export default __webpack_public_path__ + "static/media/rafSlide3.ee926041.png";